module.exports = __webpack_public_path__ + "static/media/insect(4).d599c473.PNG";